import React from 'react';

import PropTypes from 'prop-types';
import * as cn from 'classnames';

const TYPE_OPTS = {
  display: 'text-display',
  'page-title': 'text-pagetitle',
  subtitle: 'text-subtitle',
  heading: 'text-heading',
  subheading: 'text-subheading',
  body: 'text-body',
  caption: 'text-caption',
  overline: 'text-overline',
};

function Text({ type, className, children, color, weight, leading }) {
  const headerStyleOpts = ['display', 'page-title', 'subtitle'];
  const style = {
    fontStyle: TYPE_OPTS?.[type],
  };

  return (
    <div
      className={cn(
        className,
        Boolean(color) && `text-${color}`,
        Boolean(weight) && `font-${weight}`,
        Boolean(leading) && `leading-${leading}`,
        style?.fontStyle
      )}
    >
      {Boolean(children) &&
        (headerStyleOpts?.includes(type) ? (
          <h1>{children}</h1>
        ) : (
          <span>{children}</span>
        ))}
    </div>
  );
}

Text.defaultProps = {
  type: 'body',
  children: false,
  className: '',
  color: '',
  weight: '',
  leading: '',
};

Text.propTypes = {
  type: PropTypes.oneOf(Object.keys(TYPE_OPTS)),
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  className: PropTypes.string,
  weight: PropTypes.string,
  color: PropTypes.string,
  leading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(['normal', 'relaxed', 'loose']),
  ]),
};

export default Text;
